function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.194 20.159l-5.462-5.462A9.55 9.55 0 0019.2 9.599C19.199 4.297 14.9 0 9.599 0A9.599 9.599 0 000 9.6a9.599 9.599 0 0015.082 7.877l5.397 5.397c.375.375.866.562 1.357.562a1.92 1.92 0 001.358-3.277zm-13.595-4.07a6.489 6.489 0 110-12.978 6.489 6.489 0 010 12.977z",
  fill: "#060505",
  fillRule: "nonzero"
});
function SvgFeatureSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgFeatureSearch;